import { Injectable } from "@angular/core";
import { AbstractControl } from "@angular/forms";

@Injectable({
	providedIn: "root",
})
export class MessageService {
	defaultMessage: string = "required";
	messages = {
		maxlength: "validation-maxlength",
		requiredInfoDecreto: "validation-requiredInfoDecreto",
		requiredMail: "validation-requiredMail",
		cfInvalidoFormalmente: "validation-cfInvalidoFormalmente",
		invalidCF:	"validation-invalidCF",
		nSentenza: "validation-nSentenza",
		required: "validation-required",
		email: "validation-email",
		tel: "validation-tel",
		iban: "validation-iban",
		partitaIVAInvalida: "validation-partitaIVAInvalida",
		partitaIVAMaxLen2: "validation-partitaIVAMaxLen2",
		money: "validation-money",
		invalidName: "validation-invalidName",
		invalidDate: "validation-invalidDate",
		pattern: "validation-pattern",
		invalidDateFormat: "validation-invalidDateFormat",
		requiredDefinizione: "validation-requiredDefinizione",
		validationServiceFailed: "validation-validationServiceFailed",
		cfValidationPG: "validation-cfValidationPG",
		cfDifferentRichiedente:	"validation-cfDifferentRichiedente",
		requiredDomicilio: "validation-requiredDomicilio",
		requiredSede: "validation-requiredSede"
	};
	constructor() { }

	produceMessage(errorType: string, control: AbstractControl): string {
		if (Object.keys(control.errors)[0]) {
			return this.getMessage(Object.keys(control.errors)[0]);
		} else {
			return this.getMessage(this.defaultMessage);
		}
	}

	getMessage(messageKey: string): string {
		const message = this.messages[messageKey];
		if (message) {
			return message;
		} else {
			return messageKey;
		}
	}

	produceCFMessage(control: AbstractControl) {
		let message: string = this.getMessage(this.defaultMessage);
		if (control.hasError("cfInvalidoFormalmente")) {
			message = this.messages["cfInvalidoFormalmente"];
		} else if (control.hasError("invalidCF")) {
			message = this.messages["invalidCF"];
		} else if (control.hasError("cfDifferentRichiedente")) {
			message = this.messages["cfDifferentRichiedente"];
		}
		return message;
	}

	getErrorData(control: AbstractControl): string {
		let message: string = this.getMessage(this.defaultMessage);
		if (control.hasError("required") && !control.errors.matDatepickerParse) {
			message = this.messages["required"];
		} else if (control.hasError("invalidDate")) {
			message = this.messages["invalidDate"];
		} else if (control.errors.matDatepickerParse) {
			message = this.messages["invalidDateFormat"];
		}
		return message;
	}
}
